import './core'
import { Mobile, Carousel_CoreInit, getCarouselGutterWidth, iOS, Android, Accordion } from './core'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Fancybox from '@fancyapps/fancybox'
import Header from './modules/header'
import Navigator from './modules/navigator'
import './modules/opportunity'
import './plugins/territoire'
import './plugins/contact-form'
import './plugins/newsletter-form'
import './plugins/ajax-post-toolbar'
import './plugins/senraciner'
import './plugins/scroll-to-anchor'
import './plugins/thumbnail-gallery'
import './plugins/sticky-menu'
import './plugins/audio-card'
import './plugins/audio-player'
import './plugins/post-share'
import './modules/keywords'
import './modules/home-slider'
import './modules/infinite-scroll'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    burger: undefined,
    navigation: undefined,
    navigators: {
      current: undefined,
      opportunity: undefined,
    },
  }

  if (iOS() || Android()) {
    hastouch()
  }

  function initializePage() {
    Carousel_CoreInit([
      {
        classSelector: 'carousel--custom',
        swiperOptions: {
          loopAdditionalSlides : 20,
          loop : true,
        },
      },
      {
        classSelector: 'carousel--gallery',
        swiperOptions: {
          centeredSlides: true,
          initialSlide: 1,
        },
      },
      {
        classSelector: 'carousel--postitem__news',
        swiperOptions: {
          pagination: {
            renderBullet: function(index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>'
            },
          },
        },
      },
      {
        classSelector: 'carousel--style--opportunity',
        swiperOptions: {
          breakpoints: {
            768: {
              slidesPerView: 3,
              loopedSlides: 6,
              spaceBetween: getCarouselGutterWidth($('.carousel--style--opportunity'))
            },
            // 1280: {
            //   slidesPerView: 4,
            //   loopedSlides: 8,
            //   spaceBetween: getCarouselGutterWidth($('.carousel--style--opportunity'))
            // },
          },
          pagination: {
            renderBullet: function(index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>'
            },
          },
        },
      },
      {
        classSelector: 'carousel--style--mixed',
        swiperOptions: {
          pagination: {
            renderBullet: function(index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>'
            },
          },
        },
      },
    ])

    /* Card media fancybox */
    $('.card-media[data-fancybox]').fancybox({
      beforeShow: function() {
        $(window).trigger('media_started')
      },
    })

    /* Video popup */
    $('.--video-link a').each(function(index) {
      $(this).fancybox({
        loop: true,
        openEffect: 'elastic',
        closeEffect: 'elastic',
        nextEffect: 'fade',
        prevEffect: 'fade'
      });
    })

    /* Contact popup */
    $('a[href="#contact"]').on('click', function() {
      $.fancybox.open({
        src: '.contact',
        type: 'inline',
        touch: false,
        buttons: ['close'],
        smallBtn: false,
        baseClass: 'fancybox-contact',
        clickOutside: false,
        hash: false,
        btnTpl: {
          close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="' + regionportneuf_l10n.CLOSE + '"><i class="icon icon-x"></i></button>',
        },
        beforeShow: function() {
          $.mlmi.burger.maybe_close()
          $('.contact-form').each(function() {
            $(this).ContactForm()
          })
        },
      })
      return false;
    })

    /* Footer gallery */
    $('[data-fancybox="footer-gallery"]').fancybox({
      buttons: ['close'],
      baseClass: 'fancybox-footer-gallery',
      infobar: false,
      transitionEffect: 'slide',
      loop: true,
      btnTpl: {
        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="' + regionportneuf_l10n.CLOSE + '"><i class="icon icon-x"></i></button>',
        arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left"><i class="icon icon-arrow-1"></i></button>',
        arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right"><i class="icon icon-arrow-1"></i></button>',
      },
      beforeClose: function() {
        let indexes = window.location.hash.split('-')
        if (indexes[0] === '#footer') {
          let carousel = $('.footer-gallery').find('.carousel').data('carousel')
          carousel.swiper.slideTo(indexes[2], 0)
        }
      }
    });

    /* Keywords canvas */
    $('.news-single__background, .page-section--words-bg').each(function() {
      $(this).KeywordsCanvas()
    })

    /* Infinite scroll */
    if ($('main[data-next-url]').length) {
      $('.app').InfiniteScroll({
        onLoad: function(loadedArticle) {
          loadedArticle.find('.news-single__background').each(function() {
            $(this).KeywordsCanvas()
          })
          loadedArticle.find('.post-share').each(function() {
            $(this).PostShare()
          })
        },
      })
    }

    /* Header */
    $('.header').each(function() {
      $(this).Header()
    })

    /* Home slider */
    $('.home-slider').each(function() {
      $(this).HomeSlider()
    })

    /* Territoire */
    $('.territoire-module').each(function() {
      $(this).Territoire()
    })

    /* Accordion */
    Accordion.init()

    /* Blogue */
    $('.ajax-post-toolbar').each(function() {
      $(this).ajaxPostToolbar('.ajax-post-toolbar-results', '.ajax-post-toolbar-load-more');
    })

    $('.newsletter-form').each(function() {
      $(this).NewsletterForm()
    })

    $('.parallax-sections').each(function() {
      $(this).senraciner()
    })

    $('.grid--thumbnail-gallery').each(function() {
      $(this).ThumbnailGallery()
    })

    /* Scroll to anchors */
    $('a[href^=#]').each(function() {
      $(this).scrollToAnchor()
    })

    /* Fade in */
    $('.front-page .text-row .col, .front-page .grid__item').addClass('slide-in')
    $('.fade-in, .slide-in').each(function() {
      $(this).FadeIn()
    })

    /* Sticky menu */
    $('main').append($('.page-section .sticky-menu-row'))
    $('.sticky-menu-row').each(function() {
      $(this).StickyMenu()
    })

    /* Down on home */
    $('.home-slider__down-arrow').on('click', function() {
      $('html, body').scrollTo($('main .page-section:eq(1)').offset().top - $('.header').height(), 350, 4, 'easeInOutQuart')
    })

    /* Back to top */
    $('.back-to-top').on('click', function() {
      $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
    })

    /* Scroll events */
    const scrollEvents = $(window).ScrollEvents()
    let scrolledDown = false,
    topArrow = $('.back-to-top').BlockElement()
    scrollEvents.add(function(top) {
      if (!scrolledDown && top > $(window).height() / 2) {
        scrolledDown = true
        topArrow.addModifier('visible')
        $('body').addClass('--scroll-top-visible')
      } else if (scrolledDown && top < $(window).height() / 2) {
        scrolledDown = false
        topArrow.removeModifier('visible')
        $('body').removeClass('--scroll-top-visible')
      }
    })

    /* Audio card */
    $('.card-audio').each(function() {
      $(this).AudioCard()
    })

    /* Card media player */
    $('.card-media-player--soundcloud, .card-media-player--audio').each(function() {
      let self = $(this),
      player = self.AudioPlayer()
      self.parent().on('click', function(e) {
        if (!$(e.target).hasClass('.card-media-player') && !$(e.target).closest('.card-media-player').length) {
          player.trigger_click()
        }
      })
    })

    /* Post share */
    $('.post-share').each(function() {
      $(this).PostShare()
    })
  }

  /* Initialize page */
  if (!$('body').hasClass('single-navigator-content')) {
    initializePage()
  }

  /* Opportunités et ressources */
  function getCarouselIndex(opportunity_id) {
    let gridCard = $('.grid--style--opportunity .grid__item:not(.swiper-slide-duplicate) .card-opportunity[data-id="' + opportunity_id + '"]')
    if (gridCard.length) {
      if (gridCard.parent().hasClass('swiper-slide')) {
        return parseInt(gridCard.parent().attr('data-swiper-slide-index'), 10)
      } else {
        return gridCard.parent().index()
      }
    }
    return -1
  }
  function displayViewAllOpportunities() {
    let navigator = $.mlmi.navigators.opportunity,
    content = navigator.navigation.view_all_content.clone()
    if ($('body').hasClass('single-navigator-content')) {
      $('html, body, head').removeClass('single-navigator-content')
      $('main .page-section').replaceWith(content.find('.page-section'))
      $('.page-section').last().after(content.find('.view-all-styles'))
      $('.footer-styles').last().after(content.find('main style'))
      $('.footer-styles').last().after(content.find('.footer-styles'))
      initializePage()
      navigator.navigation.registerLinks()
    }
    let cardCount = 1
    content.find('.opportunity').each(function() {
      let carouselIndex = getCarouselIndex($(this).attr('data-id'))
      if (carouselIndex !== -1) {
        let card = $(this).clone().attr('data-index', '' + carouselIndex)
        card = card.SingleOpportunity()
        let added = navigator.add_card(card)
        if (added) {
          cardCount += 1
        }
      }
    })
    if (cardCount < 5) {
      let cardOffset = cardCount
      while (cardOffset < 5) {
        content.find('.opportunity').each(function() {
          let carouselIndex = getCarouselIndex($(this).attr('data-id'))
          if (carouselIndex !== -1) {
            carouselIndex += cardOffset
            let card = $(this).clone().SingleOpportunity()
            card.attr('data-index', '' + carouselIndex)
            let added = navigator.add_card(card, true)
            if (added) {
              cardCount += 1
            }
          }
        })
        cardOffset = cardCount
      }
    }
    navigator.initialize_cards()
    requestAnimationFrame(function() {
      navigator.browser.addModifier('ready')
    })
  }
  $.mlmi.navigators.opportunity = Navigator.init({
    singleClass: 'single-navigator-content',
    navigatorPageLoad: function(mainContent, navigator) {
      $.mlmi.navigators.current = navigator
      let mainCard = mainContent,
      carouselIndex = getCarouselIndex(mainCard.attr('data-id'))
      mainCard.attr('data-index', '' + carouselIndex)
      mainCard = mainCard.SingleOpportunity()
      let added = navigator.add_card(mainCard, true)

      requestAnimationFrame(function() {
        navigator.current_index = parseInt(mainCard.attr('data-index'), 10)
        navigator.browser.addModifier('initial')
        if ('navigation' in navigator && 'view_all_content' in navigator.navigation) {
          displayViewAllOpportunities()
        } else {
          navigator.navigation.display_content = true
        }
      })
    },
    navigationOptions: {
      selectors: {
        links: '.card-opportunity a',
      },
    },
  })
  if ($('.card-opportunity').length || $('body').hasClass('single-navigator-content')) {
    let viewAllURL = '/view-all/'
    if ($('body').hasClass('content-type-ressource')) {
      viewAllURL += 'ressource/'
    } else {
      viewAllURL += 'opportunity/'
    }
    if (regionportneuf_l10n.LOCALE == 'en') {
      viewAllURL = '/en' + viewAllURL
    }
    $.mlmi.navigators.opportunity.navigation.view_all_request = $.get(viewAllURL, function(x) {
      $.mlmi.navigators.opportunity.navigation.view_all_content = $('<html>').html(x)
      if ('display_content' in $.mlmi.navigators.opportunity.navigation) {
        displayViewAllOpportunities()
      }
    })
  }
})
